import { gitHash } from '@appUtils/constants/gitHash';

const versionFormat = version => /\d+\.\d+\.\d+/.exec(version).toLocaleString();

export const versionText = version =>
  `v ${versionFormat(version)} (${gitHash ?? '-'})`;

export const supportEmail = 'takeoff@flightapp.io';
